import { useEffect } from 'react';

/**
 * A hook to mark the start and mount times of a component.
 */
export function useMarkMountTimings({
  onStart,
  onMounted,
}: {
  onStart: () => void;
  onMounted: () => void;
}) {
  useEffect(() => {
    // Mark the start as soon as the component function runs
    onStart();

    // Mark the end after the skeleton is painted
    // Double rAF ensures paint has occurred
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        onMounted();
      });
    });
  }, [onStart, onMounted]);
}
